import Vue from "vue";
import Router from "vue-router";
import { api } from "@/state/services";

Vue.use(Router);

const router = new Router({
  mode: "history",
  base: "/",
  routes: [
    {
      path: "/",
      component: () => import("./views/home"),
      meta: { authRequired: true, sponsored: 'any' },
    },
    {
      path: "/login",
      component: () => import("./views/login"),
      meta: { authRequired: false, sponsored: 'any' },
    },
    {
      path: "/login/token/:token",
      component: () => import("./views/login-in"),
      meta: { authRequired: false, sponsored: 'any' },
    },
    {
      path: "/logout",
      redirect: "/login",
    },
    {
      path: "/register",
      component: () => import("./views/register"),
      meta: { authRequired: false, sponsored: 'any' },
    },
    {
      path: "/register/:sponsor",
      component: () => import("./views/register"),
      meta: { authRequired: false, sponsored: 'any' },
    },
    {
      path: "/password-forgot",
      component: () => import("./views/password-forgot"),
      meta: { authRequired: false, sponsored: 'any' },
    },
    {
      path: "/password-change",
      component: () => import("./views/password-change"),
      meta: { authRequired: false, sponsored: 'any' },
    },
    {
      path: "/account",
      component: () => import("./views/account/account"),
      meta: { authRequired: true, sponsored: 'any' },
    },
    {
      path: "/account/documents",
      component: () => import("./views/account/documents"),
      meta: { authRequired: true, sponsored: 'any' },
    },
    {
      path: "/account/address",
      component: () => import("./views/account/address"),
      meta: { authRequired: true, sponsored: 'any' },
    },
    {
      path: "/account/password",
      component: () => import("./views/account/password"),
      meta: { authRequired: true, sponsored: 'any' },
    },
    {
      path: "/account/password/security",
      component: () => import("./views/account/password-security"),
      meta: { authRequired: true, sponsored: 'any' },
    },
    {
      path: "/account/password/security/:token",
      component: () => import("./views/account/password-security"),
      meta: { authRequired: true, sponsored: 'any' },
    },
    {
      path: "/webpush",
      component: () => import("./views/webpush"),
      meta: { authRequired: true },
    },
    {
      path: "/ecosystem",
      component: () => import("./views/ecosystem"),
      meta: { authRequired: true, sponsored: 'any' },
    },
    {
      path: "/tripteev",
      component: () => import("./views/tripteev/index"),
      meta: { authRequired: true, sponsored: 'any' },
    },
    {
      path: "/nateev",
      component: () => import("./views/nateev/index"),
      meta: { authRequired: true, sponsored: 'any' },
    },
    {
      path: "/disrupteev",
      component: () => import("./views/disrupteev/index"),
      meta: { authRequired: true, sponsored: 'any' },
    },
    {
      path: "/tripteev/confirm",
      component: () => import("./views/tripteev/confirm"),
      meta: { authRequired: true, sponsored: 'any' },
    },
    {
      path: "/tripteev/cancel",
      component: () => import("./views/tripteev/cancel"),
      meta: { authRequired: true, sponsored: 'any' },
    },
    {
      path: "/tripteev/order/:id",
      component: () => import("./views/tripteev/order"),
      meta: { authRequired: true, sponsored: 'any' },
    },
    {
      path: "/plans",
      component: () => import("./views/plans/index"),
      meta: { authRequired: true, sponsored: 'any' },
    },
    {
      path: "/plans/order/:id",
      component: () => import("./views/plans/order"),
      meta: { authRequired: true, sponsored: 'any' },
    },
    {
      path: "/subscriptions",
      component: () => import("./views/subscriptions/index"),
      meta: { authRequired: true, sponsored: 'any' },
    },
    {
      path: "/subscriptions/:id",
      component: () => import("./views/subscriptions/order"),
      meta: { authRequired: true, sponsored: 'any' },
    },
    {
      path: "/account/pix",
      component: () => import("./views/account/pix"),
      meta: { authRequired: true, sponsored: 'any' },
    },
    {
      path: "/contracts",
      component: () => import("./views/contracts/list"),
      meta: { authRequired: true, sponsored: 'any' },
    },
    {
      path: "/contracts/:id",
      component: () => import("./views/contracts/view"),
      meta: { authRequired: true, sponsored: 'any' },
    },
    {
      path: "/wallet/extract",
      component: () => import("./views/wallet/extract"),
      meta: { authRequired: true, sponsored: 'any' },
    },
    {
      path: "/wallet/transfer",
      component: () => import("./views/wallet/transfer"),
      meta: { authRequired: true, sponsored: 'any' },
    },
    {
      path: "/wallet/pay",
      component: () => import("./views/wallet/pay"),
      meta: { authRequired: true, sponsored: 'any' },
    },
    {
      path: "/wallet/pay/:id",
      component: () => import("./views/wallet/pay"),
      meta: { authRequired: true, sponsored: 'any' },
    },
    {
      path: "/wallet/withdrawal",
      component: () => import("./views/wallet/withdrawal"),
      meta: { authRequired: true, sponsored: 'any' },
    },
    {
      path: "/wallet/withdrawal/history",
      component: () => import("./views/wallet/withdrawal-history"),
      meta: { authRequired: true, sponsored: 'any' },
    },
    {
      path: "/network/clients",
      component: () => import("./views/network/clients"),
      meta: { authRequired: true, sponsored: 'any' },
    },
    {
      path: "/network/sponsored",
      component: () => import("./views/network/sponsored"),
      meta: { authRequired: true, sponsored: 'any' },
    },
    {
      path: "/network/team",
      component: () => import("./views/network/team"),
      meta: { authRequired: true, sponsored: 'any' },
    },
    {
      path: "/network/binary",
      component: () => import("./views/network/binary"),
      meta: { authRequired: true, sponsored: 'any' },
    },
    {
      path: "/network/binary/:id",
      component: () => import("./views/network/binary"),
      meta: { authRequired: true, sponsored: 'any' },
    },
    {
      path: "/network/matriz",
      component: () => import("./views/network/matriz"),
      meta: { authRequired: true, sponsored: 'any' },
    },
    {
      path: "/network/unilevel",
      component: () => import("./views/network/unilevel"),
      meta: { authRequired: true, sponsored: 'any' },
    },
    {
      path: "/network/unilevel/:id",
      component: () => import("./views/network/unilevel"),
      meta: { authRequired: true, sponsored: 'any' },
    },
    {
      path: "/reports/bonus",
      component: () => import("./views/reports/bonus"),
      meta: { authRequired: true, sponsored: 'any' },
    },
    {
      path: "/reports/evolucao",
      component: () => import("./views/reports/evolucao"),
      meta: { authRequired: true, sponsored: 'any' },
    },
    {
      path: "/reports/indicacao",
      component: () => import("./views/reports/indicacao"),
      meta: { authRequired: true, sponsored: 'any' },
    },
    {
      path: "/reports/binario",
      component: () => import("./views/reports/binario"),
      meta: { authRequired: true, sponsored: 'any' },
    },
    {
      path: "/reports/lucroatacado",
      component: () => import("./views/reports/lucroatacado"),
      meta: { authRequired: true, sponsored: 'any' },
    },
    {
      path: "/reports/recompra",
      component: () => import("./views/reports/recompra"),
      meta: { authRequired: true, sponsored: 'any' },
    },
    {
      path: "/reports/carreira",
      component: () => import("./views/reports/carreira"),
      meta: { authRequired: true, sponsored: 'any' },
    },
    {
      path: "/reports/lideranca",
      component: () => import("./views/reports/lideranca"),
      meta: { authRequired: true, sponsored: 'any' },
    },
    {
      path: "/reports/participacao",
      component: () => import("./views/reports/participacao"),
      meta: { authRequired: true, sponsored: 'any' },
    },
    {
      path: "/reports/graduation",
      component: () => import("./views/reports/graduation"),
      meta: { authRequired: true, sponsored: 'any' },
    },
    {
      path: "/store",
      redirect: "/store/featured",
    },
    {
      path: "/store/featured",
      component: () => import("./views/store/featured"),
      meta: { authRequired: true, sponsored: 'any' },
    },
    {
      path: "/store/category/:id",
      component: () => import("./views/store/category"),
      meta: { authRequired: true, sponsored: 'any' },
    },
    {
      path: "/store/search",
      component: () => import("./views/store/search"),
      meta: { authRequired: true, sponsored: 'any' },
    },
    {
      path: "/store/cart",
      component: () => import("./views/store/cart"),
      meta: { authRequired: true, sponsored: 'any' },
    },
    {
      path: "/store/orders",
      component: () => import("./views/store/orders"),
      meta: { authRequired: true, sponsored: 'any' },
    },
    {
      path: "/store/order/:id",
      component: () => import("./views/store/order"),
      meta: { authRequired: true, sponsored: 'any' },
    },
    {
      path: "/store/franchises",
      component: () => import("./views/store/franchises"),
      meta: { authRequired: true, sponsored: 'any' },
    },
    {
      path: "/downloads",
      component: () => import("./views/downloads"),
      meta: { authRequired: true, sponsored: 'any' },
    },
    {
      path: "/faq",
      component: () => import("./views/faq"),
      meta: { authRequired: true, sponsored: 'any' },
    },
    {
      path: "/tickets",
      component: () => import("./views/tickets"),
      meta: { authRequired: true, sponsored: 'any' },
    },
    {
      path: "/tickets/:id",
      component: () => import("./views/tickets-view"),
      meta: { authRequired: true, sponsored: 'any' },
    },
    {
      path: "/courses",
      component: () => import("./views/courses/list"),
      meta: { authRequired: true, sponsored: 'any' },
    },
    {
      path: "/courses/:course",
      component: () => import("./views/courses/view"),
      meta: { authRequired: true, sponsored: 'any' },
    },
    {
      path: "/courses/:course/:module/:lesson",
      component: () => import("./views/courses/view"),
      meta: { authRequired: true, sponsored: 'any' },
    },
    {
      path: "/informatives",
      component: () => import("./views/informatives/index"),
      meta: { authRequired: true },
    },
    {
      path: "/informatives/:id",
      component: () => import("./views/informatives/view"),
      meta: { authRequired: true },
    },
    {
      path: "/events",
      component: () => import("./views/events/index"),
      meta: { authRequired: true },
    },
    {
      path: "/events/:id",
      component: () => import("./views/events/view"),
      meta: { authRequired: true },
    },
    {
      path: "/404",
      component: () => import("./views/404"),
      meta: { authRequired: false, sponsored: 'any' },
    },
    {
      path: "/:sponsor",
      redirect: "/register/:sponsor",
    },
  ],
});

router.beforeEach((to, from, next) => {
  const loggedIn = localStorage.getItem("token");

  document.title = process.env.VUE_APP_TITLE;
  next();

  if (to.meta.authRequired && !loggedIn) {
    return next("/login");
  }

  if (to.meta.authRequired && loggedIn) {
    api
      .get("user")
      .then((response) => {
        if (response.data && response.data.status == "success") {
          router.app.$store.state.account.user = response.data.user;

          if (
            response.data.user.contracts &&
            response.data.user.contracts.length > 0 &&
            to.path != "/contracts/" + response.data.user.contracts[0].id
          ) {
            return next("/contracts/" + response.data.user.contracts[0].id);
          } else if (
            response.data.user.package &&
            response.data.user.package.id &&
            response.data.user.package.id == 1 &&
            to.path !== "/ecosystem" &&
            to.path !== "/store" &&
            !to.path.startsWith("/store") &&
            !to.path.startsWith("/tripteev") &&
            !to.path.startsWith("/disrupteev") &&
            !to.path.startsWith("/nateev")
          ) {
            next("/ecosystem");
          } else if (to.meta.sponsored == 'yes' &&
            response.data.user.package.sponsored == 'no'
          ) {
            return next('/');
          }
        } else {
          return next("/login");
        }
      })
      .catch(error => {
        if (error) {
          return next("/login");
        }
      });
  } else {
    next();
  }
});

export default router;
